<form (ngSubmit)="clickFilter()">
    <section [ngClass]="{'hidden': !inModal}" class="lg:grid">

        <div class="flex flex-wrap gap-3 items-center">
            <input *ngIf="currentFilter && !expirationsSection && !reportsSection && !replacementOrderSection"
                type="text" [placeholder]="titleSearch"
                class="rounded-lg border border-light-blue focus:outline-light-blue px-2 h-32px py-2.5 flex-grow min-w-200px lg:max-w-300px w-full lg:flex-1"
                name="searchField" [(ngModel)]="currentFilter.search"
                (ngModelChange)="removeSpaces(currentFilter.search)">

            <app-date-range-picker-custom
                *ngIf="currentFilter && !reportsSection && !replacementOrderSection && !updatingDatePicker"
                [(model)]="currentFilter.date" class="flex-grow lg:flex-grow-0"></app-date-range-picker-custom>

            <div *ngIf="(replacementOrderSection || deliveryNotesSection) && addressesOptions && addressesOptions.length > 1"
                class="rounded-lg border border-light-blue focus:outline-light-blue px-2 h-32px flex items-center w-full md:w-auto min-w-200px lg:max-w-300px flex-1">
                <select name="address" class="bg-white w-full focus:outline-none cursor-pointer pr-1"
                    [(ngModel)]="currentFilter.address">
                    <option [disabled]="!replacementOrderSection" [value]="undefined">{{ 'filter_deliverynote_address' |
                        translate }}</option>
                    <option *ngFor="let item of addressesOptions" [ngValue]="item.value">{{ item.label }}</option>
                </select>
            </div>

            <div *ngIf="statusOptions"
                class="rounded-lg border border-light-blue focus:outline-light-blue px-2 h-32px w-full md:w-auto min-w-200px flex items-center lg:max-w-300px flex-grow">
                <select name="status" class="bg-white w-full focus:outline-none cursor-pointer pr-1"
                    [(ngModel)]="currentFilter.status">
                    <option *ngFor="let item of statusOptions" [ngValue]="item.value"
                        [selected]="item.value === currentFilter.status">
                        {{ item.label }}
                    </option>
                </select>
            </div>

            <div *ngIf="reportsSection"
                class="rounded-lg border border-light-blue focus:outline-light-blue px-2 h-32px flex items-center w-full md:w-auto min-w-200px lg:max-w-300px flex-1">
                <select name="reportStatus" class="bg-white w-full focus:outline-none cursor-pointer pr-1"
                    [(ngModel)]="currentFilter.reportStatus">
                    <option disabled [ngValue]="undefined">{{ 'search_input_status' | translate | titleCase }}</option>
                    <option *ngFor="let item of reportStatus" [ngValue]="item.value">{{ item.label }}</option>
                </select>
            </div>

            <input *ngIf="statusOptions&&!reportsSection"
                class="rounded-lg border border-light-blue focus:outline-light-blue px-2 h-32px flex items-center w-full md:w-auto min-w-200px lg:max-w-300px flex-1"
                type="text" name="measures" [(ngModel)]="currentFilter.measures"
                placeholder="{{ 'filter_measure' | translate | titleCase }}">

            <div *ngIf="reportsSection"
                class="rounded-lg border border-light-blue focus:outline-light-blue px-2 h-32px flex items-center w-full md:w-auto min-w-200px lg:max-w-300px flex-1">
                <select name="reason" class="bg-white w-full focus:outline-none cursor-pointer pr-1"
                    [(ngModel)]="currentFilter.reason">
                    <option disabled [ngValue]="undefined">{{ 'incidents_table_reason' | translate | titleCase }}
                    </option>
                    <option *ngFor="let item of reasonOptions" [ngValue]="item.value">{{ item.label }}</option>
                </select>
            </div>
            <div class="rounded-lg border border-light-blue focus:outline-light-blue px-2 h-32px flex items-center w-full flex-1"
                *ngIf="searchBrandsOptions?.length && !reportsSection">
                <ng-multiselect-dropdown *ngIf="searchBrandsOptions && !reportsSection" #multiselectbrands
                    class="min-w-150px flex-1" [ngModelOptions]="{standalone: true}"
                    [placeholder]="'filter_brand' | translate | titleCase" [settings]="dropdownSettings"
                    [data]="searchBrandsOptions" [(ngModel)]="selectedItemsMarcas"
                    (onSelect)="onChangeSelectMarca($event)" (onDeSelect)="onChangeSelectMarca($event)"
                    (onFilterChange)="onChangeSelectMarca($event)"
                    (click)="onClickFilterMarca()"></ng-multiselect-dropdown>
            </div>

            <div class="grid h-32px w-full lg:w-auto lg:flex-1 lg:flex-none">
                <button type="submit"
                    class="bg-black text-white border-black hover:text-primary hover:border-primary hover:bg-white font-semibold text-md rounded border transition duration-300 px-8 ">
                    {{ 'filter_btn' | translate | titleCase }}
                </button>
            </div>

            <div class="flex-1 grid justify-items-end">
                <button
                    *ngIf="type !== 'REPORTS' && !inModal && (orders?.length || deliveries?.length || bills?.length)"
                    (click)="clickExport()" type="button"
                    class="flex-1 flex items-center font-bold hover:underline whitespace-no-wrap">
                    <img src="./assets2023/img/icons/excel.svg" alt="Excel" width="24" height="24" />
                    {{ 'doc_excel_export' | translate }}
                </button>

                <button *ngIf="type === 'REPORTS' && user?.tipoUsuario !== 'COMERCIAL'"
                    (click)="clickNewIncidenceMobile()"
                    class="hidden lg:block text-white bg-secondary border-secondary hover:bg-white hover:text-primary hover:border-primary font-semibold text-md rounded border transition duration-300 px-8 w-200px h-45px">
                    + {{ 'doc_new_incident' | translate }}
                </button>
            </div>
        </div>
    </section>
</form>

<!-- Filters Mobile -->
<section *ngIf="!inModal" class="fixed bottom-0 left-0 p-3.5 bg-white flex gap-2 w-full shadow z-20 lg:hidden">

    <button type="button"
        class="bg-secondary text-white border-secondary hover:text-primary hover:border-primary hover:bg-white font-semibold text-md rounded border transition duration-300 px-8 h-45px w-full flex justify-center items-center"
        (click)="openFilterMobile()">
        <svg class="flex-shrink-0 stroke-secondary fill-white lg:stroke-white lg:fill-white" width="18" height="18"
            viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_558_30368)">
                <path
                    d="M3 3H15V4.629C14.9999 5.02679 14.8418 5.40826 14.5605 5.6895L11.25 9V14.25L6.75 15.75V9.375L3.39 5.679C3.13909 5.40294 3.00004 5.0433 3 4.67025V3Z"
                    stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_558_30368">
                    <rect width="18" height="18" />
                </clipPath>
            </defs>
        </svg>
        {{ 'filter_btn' | translate | titleCase }}
    </button>

    <button *ngIf="type === 'REPORTS' && user?.tipoUsuario !== 'COMERCIAL'" (click)="clickNewIncidenceMobile()"
        class="text-white bg-secondary border-secondary hover:bg-white hover:text-primary hover:border-primary font-semibold text-md rounded border transition duration-300 px-2 h-45px w-full">
        + {{ 'doc_new_incident' | translate }}
    </button>

    <button *ngIf="type !== 'REPORTS' && (orders?.length || deliveries?.length || bills?.length)"
        class="w-1/5 sm:w-full rounded sm:border sm:border-black flex items-center justify-center font-bold hover:underline"
        (click)="clickExport()">
        <img src="./assets2023/img/icons/excel.svg" alt="Excel" width="24" height="24" />
        <span class="hidden sm:block">{{ 'doc_excel_export' | translate }}</span>
    </button>
</section>

<div *ngIf="withFilters && !inModal" class="flex items-center gap-2 lg:mt-6">
    <div>
        <span class="font-semibold">
            {{ 'filter_filterby' | translate }}:
        </span>
        <span *ngIf="applyFilter?.search">{{titleSearch}} ({{applyFilter?.search}})</span>
        <span *ngIf="applyFilter?.date"> {{getStrSearchDate()}}</span>
        <span *ngIf="applyFilter?.status && currentFilter.status"> {{'filter_state'|translate}}
            {{getStrSearchStatus()}}</span>
        <span *ngIf="applyFilter?.reportStatus && currentFilter.reportStatus"> {{'filter_state'|translate}}
            {{getStrSearchReportStatus()}}</span>
        <span *ngIf="applyFilter?.reason"> {{'filter_motiv'|translate}} {{applyFilter?.reason}}</span>
        <span *ngIf="applyFilter?.measures"> {{'filter_measure'|translate}} {{applyFilter?.measures}}</span>
        <span *ngIf="applyFilter?.brand"> {{'filter_brand'|translate}} {{applyFilter?.brand}}</span>
    </div>

    <!-- Delete filter -->
    <div class="flex-shrink-0">
        <button (click)="clickClearFilters($event)"
            class="group focus:outline-none w-6 h-6 flex items-center justify-center bg-primary border border-primary rounded-full transition ease-out duration-300 hover:bg-white">
            <svg class="fill-white group-hover:fill-primary transition ease-out duration-300" width="8" height="8"
                viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M0.306008 0.306008C0.714019 -0.102003 1.37557 -0.102003 1.78359 0.306008L4 2.52242L6.21632 0.306106C6.62433 -0.101905 7.28578 -0.101905 7.69389 0.306106C8.1019 0.714117 8.1019 1.37567 7.69389 1.78368L5.47758 3.99995L7.69389 6.21627C8.1019 6.62428 8.1019 7.28583 7.69389 7.69384C7.28588 8.10186 6.62433 8.10186 6.21632 7.69384L4 5.47753L1.78359 7.69399C1.37557 8.102 0.714019 8.102 0.306008 7.69399C-0.102003 7.28598 -0.102003 6.62443 0.306008 6.21641L2.52247 3.99995L0.306057 1.78354C-0.102003 1.37553 -0.102003 0.714019 0.306008 0.306008Z" />
            </svg>
        </button>
    </div>
</div>